<header #floatingNav>
  <content>
    <img
      src="../../../assets/images/logo-mobile.svg"
      alt="mobile logo"
      class="logo"
    />
    <div class="desktop-nav">
      <app-nav-links></app-nav-links>
    </div>
  </content>
</header>
